module.exports = __webpack_public_path__ + "img/subBanner3.7e0676b5.png";